import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from './auth.service';
@Injectable()
export class AuthGuard implements CanActivate {
  constructor(private router: Router,
    private auth: AuthService) { }

     canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const currentUser = this.auth.currentUserValue;
        // console.log('Auth......',this.auth.currentUserValue);
        if (currentUser) {
            // check if route is restricted by role
            // console.log('routing......',route.data.roles, route.data.roles.indexOf(currentUser.userroleid));
            if (route.data.roles && route.data.roles.indexOf(currentUser.userroleid) === -1) {
              // console.log("inside IFFFFFF ");
                // role not authorised so redirect to home page
                //this.router.navigate(['/']);
              //  return false;
            }
 
            // authorised so return true
            return true;
        }

        // not logged in so redirect to login page with the return url
        // console.log("state URL",state);
        this.router.navigate(['/login'], { queryParams: { returnUrl: state.url }});
        return false;
    }
}